import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";

export default class MarketersStore {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "MarketersStore",
      properties: ["marketerAnalysis"],
    });
  }

  marketerAnalysis = [];

  reset = () => {
    this.marketerAnalysis = [];
  };

  setMarketerAnalysis = async (state) => {
    runInAction(() => {
      this.marketerAnalysis = state;
    });
  };
}
